import { Box } from "@mui/material";
import { useIsTwoPane } from "feat/layout/screen-layout";
import { useLocation } from "react-router-dom";
import { routes } from "routing";
import { HomeTabs } from "./slide/footer/HomeTabs";

export function CarouselFooter() {
  const { pathname } = useLocation();
  // Two panes carry Summary and Map on the bar or rail (the web's rail, iOS's native Map tab), so
  // Home's header offers them in one pane only.
  const twoPane = useIsTwoPane();
  const onHome = pathname === routes.home.path && !twoPane;
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: "0px",
        // The column's width, when the header runs on under a vertical bar (see CarouselContainer).
        left: "var(--header-bleed-left, 0px)",
        right: "var(--header-bleed-right, 0px)",
        zIndex: 100,
        transition: "opacity 0.2s",
        opacity: onHome ? 1 : 0,
        pointerEvents: onHome ? "auto" : "none",
      }}
    >
      <HomeTabs />
    </Box>
  );
}
